export default __webpack_public_path__ + "static/media/about-top-sp.78c06987.jpg";